import { render, staticRenderFns } from "./DuckRace.vue?vue&type=template&id=70063acc&scoped=true"
import script from "./DuckRace.vue?vue&type=script&lang=ts"
export * from "./DuckRace.vue?vue&type=script&lang=ts"
import style0 from "./DuckRace.vue?vue&type=style&index=0&id=70063acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70063acc",
  null
  
)

export default component.exports